<div class="SubscriptionsListing">
  <div class="SubscriptionsListing-header mb-5">
    <h4 class="title__page">Team codes</h4>
  </div>
  <div class="SubscriptionListing-button pb-3">
    <app-button
      [style]="createButtonProperties.style"
      [text]="createButtonProperties.text"
      [size]="createButtonProperties.size"
      [color]="createButtonProperties.color"
      [route]="createButtonProperties.route"></app-button>
  </div>
  <div class="SubscriptionListing-table">
    <app-table
      *ngIf="tableReady"
      [columns]="tableColumns"
      [dataSource]="dataSource"
      [dataSourceParams]="tableDataSourceParams"></app-table>
  </div>
</div>
